import { useContext } from "react";

import { AnalyticsContext } from "./analytics-context";

export const useAnalyticsContext = () => useContext(AnalyticsContext);
